import React from "react";

const NotFoundContainer = () => {
  return <p>Not found</p>;
};

// const mapStateToProps = state => {
//     return (
//         { ...state.createAvatarReducer }
//     )
// }

// const mapDispatchToProps = dispatch => ({
//     getAvatar: (data) => dispatch(getAvatar(data))
// })

// export default connect(mapStateToProps,mapDispatchToProps)(AvatarPageContainer)

export default NotFoundContainer;
